import React from "react";
import aboutImg from "../images/about/pp.jpg";
import { Skills } from "./Skills";
import { useI18n } from "../i18n";

export const About = () => {
  const { t } = useI18n();

  return (
    <section id="about" className="section about">
      <div className="section-title">
        <h2>
          <span>{t.about.title}</span>
        </h2>
        <div className="underline"></div>
      </div>

      <div className="section-center about-center">
        {/* about-img  */}
        <article>
          <div className="about-img">
            <img
              src={aboutImg}
              alt={t.about.imgAlt}
              className="about-image"
              width="400"
              height="400"
              loading="lazy"
            />
          </div>
        </article>

        <article className="about-info">
          <p>
            {t.about.p1intro} <strong>{t.about.p1name}</strong>
            {t.about.p1}
          </p>
          <p>{t.about.p2}</p>
          <p>
            {t.about.p3before}&nbsp;
            <a
              href="https://thebridge-news.beehiiv.com/"
              target="_blank"
              rel="noreferrer"
              title={t.about.p3link}
            >
              {t.about.p3link}
            </a>
            &nbsp;{t.about.p3after}
          </p>

          {/* stack */}
          <Skills />
        </article>
      </div>
    </section>
  );
};
